export default{
    initState:{
        email: '',
        password: '',
        initName:null,
        userName : '',
        userEmail:null, 
        error:'',
        authenticated: false,
        isFetching:true,
        agreedTerms: false,
        showError:false,
        showSuccessAlert:false,
        showFailureAlert:false,
        getTokenSuccessAlert:false,
        getTokenFailureAlert:false,
        emailSuccess:null,
        emailFail:null,
        currentNode:null,
        currentLimit:null,
        currentFromDate:null,
        currentToDate:null,
        manager:false,
        token:null,
        tokens:null,
        userId:null,
        nodeInfoSuccess:null
    }
    
};


// WEBPACK FOOTER //
// ./src/reducers/initialState.js